import { lazy, Suspense, useState, useEffect } from "react";
import CommonLoader from "./Components/Commonloader/commonloader";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  Navigate,
} from "react-router-dom";
import usePageTracking from "./usePageTracking";
import { useRootStore } from "./pages/ExperianPage/store/rootContext";
import InclusionExclusion from "./pages/InclusionExclusion/InclusionExclusion";
import ProtectedRoute from "./Components/routingRestrict/ProtectedRoute";
import InfoBar from "./Components/InfoBar/InfoBar";
import { Toaster } from "react-hot-toast";
import ToastListener from "./Components/ToastComponent/ToastListener";
import CookieConsentPopup from "./pages/Cookies/Cookies";
import {
  refreshSessionApi,
  accessTokenAvailable,
} from "./Components/CommonPathWay";
import { observer } from "mobx-react-lite";
import { runInAction } from "mobx";
const Login = lazy(() => import("./pages/Authentication/Login"));
const SignUp = lazy(() => import("./pages/Authentication/SignUp"));
const Reset = lazy(() => import("./pages/Authentication/Reset"));
const TopNavBar = lazy(() => import("./Components/NavBar/TopNavBar"));
const SideNavBar = lazy(() => import("./Components/SideBar/SideNavBar"));
const SavedSearch = lazy(() => import("./pages/SavedTable/index"));
const Subscription = lazy(() => import("./pages/Subscription/index"));
const DynamicDashboard = lazy(() =>
  import("./pages/DynamicDashboard/DynamicDashboard")
);
const Dashboard = lazy(() =>
  import("./pages/Dashboard/index")
);
const ManageUsers = lazy(() =>
  import("./pages/ManageUsersExperian/ManageUsers")
);
const SubscriptionConfig = lazy(() =>
  import("./pages/SubscriptionConfig/SubscriptionConfig")
);
const UserProfile = lazy(() => import("./pages/Profile-Page/UserProfile"));
const CRMintegrations = lazy(() =>
  import("./pages/ExperianPage/CRMintegrations/CRMintegration")
);
const SubscriptionPage = lazy(() =>
  import("./pages/SubscriptionPage/SubscriptionPage")
);
const CRMfieldMappingPage = lazy(() =>
  import("./pages/ExperianPage/CRMintegrations/CRMfieldMapping")
);
const ProspectSaerch = lazy(() =>
  import("./pages/ProspectSearch/ProspectSearch")
);
const WorksheetSavedTable = lazy(() =>
  import("./pages/enrichTable/Enrichtable")
);
const DownloadsPage = lazy(() =>
  import("./pages/Downloads/index")
);
const MatchAppend = lazy(() =>
  import("./pages/MatchandAppend/index")
);
const CreditConfiguration = lazy(() =>
  import("./pages/CreditConfiguration/CreditConfiguration")
);
const PaymentStatus = lazy(() => import("./pages/PaymentStatus/PaymentStatus"));
const CreditLogs = lazy(() =>
  import("./pages/creditlogs/index")
);
const PaymentHistory = lazy(() => import("./pages/PaymentHistory/index"));

const hideOnPaths = ["/login", "/sign-up", "/reset-password"];
const shouldHideConsent = hideOnPaths.includes(location.pathname);

function App() {
  const [expand, setExpand] = useState(false);
  const toggleSidebar = () => {
    setExpand(!expand);
  };

  return (
    <BrowserRouter>
      <Toaster position="top-right" reverseOrder={false} />
      <ToastListener />
      <MainComponent expand={expand} toggleSidebar={toggleSidebar} />
    </BrowserRouter>
  );
}
const MainComponent = observer(({ expand, toggleSidebar }) => {
  const rootStore = useRootStore();
  const [accessToken, setAccessToken] = useState(
    localStorage.getItem("accessToken")
  );
  const [hidelocation, setHidelocation] = useState(false);
  const [errorToast, setErrorToast] = useState(false);
  const location = useLocation();
  usePageTracking(location);
  const excludedRoutes = [
    "/login",
    "/sign-up",
    "/reset-password",
    "/payment-status",
  ];

  useEffect(() => {
    const fetchTokenAndUserData = async () => {
      let token = localStorage.getItem("accessToken");

      // If not on excluded route and no access token, try to refresh session
      if (
        !excludedRoutes.includes(location.pathname) &&
        (!token || token === "undefined" || token === null)
      ) {
        let response = await refreshSessionApi();
        if (response?.status === 419) {
          setErrorToast(true);
          response = await refreshSessionApi();
        }
        if (response?.status === 440) {
          localStorage.clear();
          let invite = null;
          console.log(location, "loc30");
          const urlParams = new URLSearchParams(location.search);
          invite = urlParams.get("invite-code");
          const state = urlParams.get("state");
          console.log(location, invite, state, "location");
          if (invite) {
            window.location.href = `/login?invite-code=${invite}`;
          } else {
            window.location.href = "/login";
          }
          return;
        }
        if (response?.data?.accessToken) {
          localStorage.setItem("accessToken", response?.data?.accessToken);
          setAccessToken(response?.data?.accessToken);
          localStorage.removeItem("loginToken");
          token = response?.data?.accessToken;
        }
      }

      // Always check for access token after possible refresh
      token = localStorage.getItem("accessToken");
      if (token && token !== "undefined" && token !== null) {
        accessTokenAvailable(location);
        rootStore.getuserdetails();
        rootStore.getUserCredits();
        rootStore.getUserPermissions();
      }
    }

    fetchTokenAndUserData();
    // eslint-disable-next-line
    if (
      rootStore?.globalAllowedRoutes.length === 0 &&
      !excludedRoutes.includes(location.pathname)
    ) {
      rootStore.handleGlobalRoutes();
    }
    if (excludedRoutes.includes(location.pathname)) {
      runInAction(() => {
        rootStore.globalPermissionsLoaded = true;
      });
    }
  }, [location.pathname]);
  useEffect(() => {
    if (
      location.pathname === "/login" ||
      location.pathname === "/sign-up" ||
      location.pathname === "/reset-password"
    ) {
      setHidelocation(true);
    } else {
      setHidelocation(false);
    }
  }, [location.pathname]);
  if (!rootStore.globalPermissionsLoaded) {
    return (
      <div>
        <CommonLoader />
      </div>
    );
  }

  return (
    <>
      <Suspense
        fallback={
          <div>
            <CommonLoader />
          </div>
        }
      >
        {accessToken && !excludedRoutes.includes(location.pathname) && (
          <>
            <SideNavBar expanded={expand} toggleSidebar={toggleSidebar} />
            <TopNavBar expanded={expand} toggleSidebar={toggleSidebar} />
          </>
        )}

        {<CookieConsentPopup />}
        <Routes>
          {accessToken ? (
            <>
              <Route path="/login" element={<Navigate to="/dashboard" replace />} />
              <Route path="/sign-up" element={<Navigate to="/dashboard" replace />} />
              <Route path="/reset-password" element={<Navigate to="/dashboard" replace />} />
            </>
          ) : (
            <>
              <Route path="/login" element={<Login />} />
              <Route path="/sign-up" element={<SignUp />} />
              <Route path="/reset-password" element={<Reset />} />
            </>
          )}

          <Route
            path="/payment-status"
            element={
              <ProtectedRoute path="/payment-status">
                <PaymentStatus />
              </ProtectedRoute>
            }
          />
          <Route
            path="/crm-fieldmapping"
            element={<CRMfieldMappingPage expanded={expand} />}
          />
          <Route
            path="/subscription-config"
            element={<SubscriptionConfig expanded={expand} />}
          />
          {/* Conditional rendering for protected routes */}
          {rootStore?.globalAllowedRoutes.includes(location.pathname) ? (
            <>
              <Route
                path="/dashboard"
                element={<Dashboard expanded={expand} />}
              />
              <Route
                path="/crm-integration"
                element={<CRMintegrations expanded={expand} />}
              />
              <Route
                path="/crm-fieldmapping"
                element={<CRMfieldMappingPage expanded={expand} />}
              />
              <Route
                path="/prospect-search"
                element={<ProspectSaerch expanded={expand} />}
              />
              <Route
                path="/data-enrichment"
                element={<MatchAppend expanded={expand} />}
              />
              <Route
                path="/saved-search"
                element={
                  <ProtectedRoute path="/saved-search">
                    <SavedSearch expanded={expand} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/subscription-page"
                element={
                  <ProtectedRoute path="/subscription-page">
                    <Subscription expanded={expand} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/credit-configuration"
                element={
                  <ProtectedRoute path="/credit-configuration">
                    <CreditConfiguration expanded={expand} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/inclusion-exclusion"
                element={
                  <ProtectedRoute path="/inclusion-exclusion">
                    <InclusionExclusion expanded={expand} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute path="/profile">
                    <UserProfile expanded={expand} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/saved-table"
                element={
                  <ProtectedRoute path="/saved-table">
                    <DownloadsPage expanded={expand} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/manage-user"
                element={<ManageUsers expanded={expand} />}
              />

              <Route
                path="/payment-history"
                element={<PaymentHistory expanded={expand} />}
              />

              <Route
                path="/credit-logs"
                element={<CreditLogs expanded={expand} />}
              />

              {/* Catch-all for protected routes, redirects to dashboard */}
              <Route path="*" element={<Navigate to="/dashboard" />} />
            </>
          ) : (
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          )}
        </Routes>
      </Suspense>
      <InfoBar
        Information={"Something went wrong, Please try again"}
        popupState={errorToast}
        setPopupState={setErrorToast}
        flag={false}
      />
    </>
  );
});
export default observer(App);
